export const ENTER_CTA_LINK = '/choose-your-plan';